/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [date-box-small.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 03.02.20, 16:32
 */
import React from 'react';
import {BlockedSvg, BoundedHtmlTooltip} from "./date-box-flat";
import {formatFns, formatShortFns} from "../../configuration/configuration";
import {Schedule, TodayOutlined} from "@material-ui/icons";
import {cn} from "../../util/text-utils";
import {EventEndIcon} from "../../navigation/icons/nav-icons";

// time in ISO as HH:MM:SS
export const splitSeconds = (time) => {
    if (!time) return null;
    const last = time.lastIndexOf(':')
    return time.substring(0, last);
}

// time in ISO as HH:MM:SS
export const splitTime = (time) => {
    const times = time ? time.split(':') : ['0', '0', '0'];
    return {hour: times[0], min: times[1], sec: times[2]}
}

// date in ISO as YYYY-MM-dd
export const splitDate = (date, long = false) => {
    const pattern = long ?  'MMM dd EEEE' : 'MMM dd EE'
    const dates = date ? formatFns(new Date(date), pattern).split(" ")
        : ['', '', '']
    return {month: dates[0], day: dates[1], weekday: dates[2]}
}

// displays additionally html code in a tooltip on hover, date and times as strings in ISO format
export const DateTimeBoxLong = ({date, startTime, endTime, blocked, className, html, full}) => {

    if (!date) return null;
    const {month, day, weekday} = splitDate(date, true);

    return <div className='d-flex flex-wrap'>
        <BoundedHtmlTooltip className={`date-box-flat ${className && className}`} html={html}>

            <div className="date-box-flat-month">{month}</div>
            <div className="date-box-flat-day">{day}</div>
            <div className="date-box-flat-weekday">{weekday}</div>

            {blocked &&
            <span className="date-box-small-blocked">
                <BlockedSvg/>
            </span>}
        </BoundedHtmlTooltip>

        {(startTime || endTime) &&
        <div className="date-box-flat-time pt-1">
            <Schedule className='mr-1'/> {splitSeconds(startTime)}-{splitSeconds(endTime)}
        </div>}

    </div>
}

export const DateTimeBoxSimple = ({date, startTime, endTime, className, isEndDate= false}) => {
    if (!date) return null;

    return <div className={cn('box-aligned flex-wrap', [className])}>
        <div className='sidebar-space-date mr-1'>
            {isEndDate? <EventEndIcon xsmall={true} className='mr-1' /> : <TodayOutlined className='font-1x mr-1'/>}
            <span className='fw-bolder text-danger'>{formatShortFns(date)}</span>
        </div>

        {(startTime || endTime) &&
            <div className="box-aligned sidebar-space-date">
                <Schedule className='font-1x mr-1'/>
                <span>{splitSeconds(startTime)}-{splitSeconds(endTime)}</span>
            </div>}

    </div>
}

export const DateTimeSimpleBigger = ({date, startTime, endTime, className}) => {
    if (!date) return null;

    return <div className={cn('box-aligned flex-wrap mt-1', [className])}>
        <div className='mr-1'>
            <TodayOutlined className='mr-1'/>{formatShortFns(date, 'dd MMM dd, EE')}
        </div>

        {(startTime || endTime) &&
            <div className="box-aligned">
                <Schedule className='mr-1'/>
                <span>{splitSeconds(startTime)}-{splitSeconds(endTime)}</span>
            </div>}

    </div>
}

// same as boxed version  but on one line
export const DateTimeFlatLong = ({date, startTime, endTime, blocked, className, html, full}) => {

    if (!date) return null;
    const {month, day, weekday} = splitDate(date, true);

    return <React.Fragment>
        <BoundedHtmlTooltip className={`date-box-flat ${className && className}`} html={html}>

            <div className="date-box-flat-month">{month}</div>
            <div className="date-box-flat-day">{day}</div>
            <div className="date-box-flat-weekday">{weekday}</div>

            {blocked &&
            <span className="date-box-small-blocked">
                <BlockedSvg/>
            </span>}

            {(startTime || endTime) &&
            <div className="date-box-flat-time ml-2">
                <Schedule className='mr-1'/> {splitSeconds(startTime)}-{splitSeconds(endTime)}
            </div>}
        </BoundedHtmlTooltip>

    </React.Fragment>
}